import Modal from 'react-modal';

import { connect } from 'react-redux';
import React, { Component, lazy } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { get } from 'lodash';
import BtnClickModal from '../components/modals/BtnClickModal';
import PromptModal from '../components/modals/PromptModal';
import OnscreenNudgeModal from '../components/modals/OnscreenNudgeModal';
import InviteEmployees from '../components/modals/InviteEmployees';
import BulkInviteEmployees from '../components/modals/BulkInviteEmployees';
import HelpModal from '../components/modals/HelpModal';
import PrintPreviewModal from '../components/modals/PrintPreviewModal';

import { hideModal } from '../actions';
import { MODALS } from '../Constants';

const GrowthPDFModal = lazy(() => import('../components/modals/GrowthPDFModal'));
const DiscussionPromptPDFModal = lazy(() => import('../components/modals/DiscussionPromptPDFModal'));

const MODAL_COMPONENTS = {
    [MODALS.BTN_CLICK_MODAL]: {
        modalComponent: BtnClickModal
    },
    [MODALS.PROMPT_MODAL]: {
        modalComponent: PromptModal
    },
    [MODALS.ONSCREEN_NUDGE_MODAL]: {
        modalComponent: OnscreenNudgeModal
    },
    [MODALS.INVITE_EMPLOYEES]: {
        modalComponent: InviteEmployees,
        baseModalClassName: 'inviteEmployeesForm-baseModal'
    },
    [MODALS.HELP_MODAL]: {
        modalComponent: HelpModal
    },
    [MODALS.PRINT_PREVIEW_MODAL]: {
        modalComponent: PrintPreviewModal(GrowthPDFModal),
        baseModalClassName: 'growth-pdf-modal'
    },
    [MODALS.PRINT_PREVIEW_PROMPTS_MODAL]: {
        modalComponent: PrintPreviewModal(DiscussionPromptPDFModal),
        baseModalClassName: 'discussion-prompt-pdf-modal'
    },
    [MODALS.BULK_INVITE_MODAL]: {
        modalComponent: BulkInviteEmployees,
        baseModalClassName: 'bulkInviteEmployees-baseModal'
    }
};

class ModalRoot extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: true
        };
        this.customStyle = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(111, 111, 111, 0.62)',
                zIndex: 999,
                boxShadow:
                    'rgba(0, 0, 0, 0.117647) -1px 0px 2px 0px, rgba(0, 0, 0, 0.117647) 1px 0px 2px 0px, rgba(0, 0, 0, 0.239216) 0px 1px 1px 0px'
            },
            content: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                border: '1px solid #ccc',
                background: '#fff',
                overflow: 'auto',
                WebkitOverflowScrolling: 'touch',
                borderRadius: '4px',
                outline: 'none',
                padding: '20px',
                boxShadow: '0px 0px 24px -2px #242424'
            }
        };
    }

    static propTypes = {
        hideModal: PropTypes.func,
        modal: PropTypes.any,
        modalType: PropTypes.string,
        modalProps: PropTypes.any
    };

    afterOpenModal = () => {
        if (this.refs.subtitle) {
            // references are now sync'd and can be accessed.
            this.refs.subtitle.style.color = '#f00';
        }
    };

    closeModal = () => {
        const { hideModal } = this.props;
        const { onClose } = this.props.modalProps;
        if (onClose) {
            onClose();
        }
        hideModal();
    };

    render() {
        const { modalType, modalProps } = this.props;
        if (!modalType) {
            return null;
        }

        const SpecificModal = MODAL_COMPONENTS[modalType].modalComponent;
        const baseModalClassName = get(MODAL_COMPONENTS[modalType], 'baseModalClassName', '');

        return (
            <Modal
                className={cns(baseModalClassName, 'modalContainer')}
                style={this.customStyle}
                isOpen={this.state.modalIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                contentLabel={'Modal'}
            >
                <div className={cns('baseModal')}>
                    <div className={'close-container'}>
                        <button className={'x'} onClick={this.closeModal} />
                    </div>
                    <div>
                        <SpecificModal {...modalProps} closeModal={this.closeModal} />
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        modal: { modalType, modalProps },
        mobile: { isMobile }
    } = state;
    return {
        modalType,
        modalProps,
        isMobile
    };
};

const mapDispatchToProps = (dispatch) => ({
    hideModal: () => dispatch(hideModal())
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalRoot);
